<div class="row">
	<div class="col-lg-12">
		<div class="ibox float-e-margins">
			<div class="ibox-content">
				<h4>Block List Details</h4>

				<!--Table-->
				<div class="table-main-body">
					<p-table
						#mydt
						[value]="lstStationBlockAlert"
						[loading]="loading"
						[paginator]="true"
						[(rows)]="pagerows"
						[(first)]="pagefirst"
						[showCurrentPageReport]="true"
						[resizableColumns]="false"
						sortMode="multiple"
						styleClass="p-datatable-striped"
						selectionMode="single"
						[(selection)]="SelectedStationBlockAlert"
						dataKey="StationBlockAlertID"
						(onFilter)="onHandleFilter($event)"
						(onSort)="onHandleSort($event)"
						(onRowSelect)="onRowSelect($event)"
						(onRowUnselect)="onRowUnselect($event)"
						currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
						[rowsPerPageOptions]="[5, 10, 25, 50]"
					>
						<!--Headers-->
						<ng-template pTemplate="header">
							<!--Filter or Select from Dropdown-->
							<tr>
								<!--INSERT CUSTOM FILTERS HERE-->

								<!--Message-->
								<th>
									<p-columnFilter type="text" field="Message" matchMode="contains" [showMenu]="true"></p-columnFilter>
								</th>

								<!--PriorityDesc-->
								<th>
									<p-columnFilter field="PriorityDesc" matchMode="equals" [showMenu]="false">
										<ng-template pTemplate="filter" let-value let-filter="filterCallback">
											<p-dropdown
												#filterPriorityDesc
												[ngModel]="value"
												[options]="lstPriorityDesc"
												(onChange)="filter($event.value)"
												placeholder="Any"
												[showClear]="true"
											>
												<ng-template let-value pTemplate="item">
													<span>{{ value }}</span>
												</ng-template>
											</p-dropdown>
										</ng-template>
									</p-columnFilter>
								</th>

								<!--DateRangeDesc-->
								<th>
									<p-columnFilter type="text" field="DateRangeDesc" matchMode="contains" [showMenu]="true"></p-columnFilter>
								</th>

								<!--TimeDesc-->
								<th>
									<p-columnFilter type="text" field="TimeDesc" matchMode="contains" [showMenu]="true"></p-columnFilter>
								</th>
							</tr>

							<!--Column Names-->
							<tr style="height: 4rem">
								<!--INSERT CUSTOM COLUMNS HERE-->
								<th pSortableColumn="Message">Message<p-sortIcon field="Message"></p-sortIcon></th>
								<th pSortableColumn="PriorityDesc">Priority<p-sortIcon field="PriorityDesc"></p-sortIcon></th>
								<th pSortableColumn="DateRangeDesc">Date Range<p-sortIcon field="DateRangeDesc"></p-sortIcon></th>
								<th pSortableColumn="TimeDesc">Time Range<p-sortIcon field="TimeDesc"></p-sortIcon></th>
							</tr>
						</ng-template>

						<!--Data-->
						<ng-template pTemplate="body" let-StationBlockAlert>
							<tr [pSelectableRow]="StationBlockAlert">
								<td
									*ngFor="let col of cols"
									style="font-weight: bold; text-overflow: ellipsis; word-break: break-word"
									[style.color]="StationBlockAlert.DELETED == false ? 'Black' : 'Red'"
								>
									{{ StationBlockAlert[col.field] }}
								</td>
							</tr>
						</ng-template>
					</p-table>
				</div>
			</div>
		</div>
	</div>
</div>
